// https://vuex.vuejs.org/en/state.html

export default {
  activeTab: 1,
  ranking: {}
}
